import { AccordionDetailsProps } from '@mui/material';
import React from 'react';
import * as Styled from './accordion.styles';

const AccordionDetails: React.FC<AccordionDetailsProps> = ({ ...props }) => {
  return <Styled.AccordionDetails {...props} />;
};

export default React.memo(AccordionDetails);
